<div class="grid-x">
  <div class="cell small-12">
    Payment Calculation Source:
  </div>
  <div class="cell small-12">
    <div class="checkbox">
      <label>
        <input class="show-for-sr" type="checkbox" id="chkFees" [(ngModel)]="componentData.config.usePermitFees" />
        <label aria-hidden="true" for="chkFees" class="inline">
          <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
          <span class="control-label-text">Use Payment Calculator?</span>
        </label>
      </label>
    </div>
  </div>
</div>
@if (componentData.config.usePermitFees) {
  <div class="grid-x">
    <div class="cell small-12 margin-top margin-bottom">
      Context Locations for <u>Permit Data</u>:
    </div>
    <div class="cell small-6">
      New Or Existing
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="componentData.config.permitNewOrExisting" />
    </div>
    <div class="cell small-6">
      Urban Area
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="componentData.config.permitUrbanArea" />
    </div>
    <div class="cell small-6">
      Well Type
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="componentData.config.permitWellType" />
    </div>
    <div class="cell small-6">
      Well Type Description
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="componentData.config.permitWellTypeDescription" />
    </div>
    <div class="cell small-6">
      Fluid Proposed
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="componentData.config.permitFluidProposed" />
    </div>
    <div class="cell small-6">
      PropDIJVmax
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="componentData.config.permitPropDIJVmax" />
    </div>
    <div class="cell small-6">
      Unit MPn
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="componentData.config.permitUnitMPn" />
    </div>
    <div class="cell small-6">
      Expedite Permit
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="componentData.config.permitExpedite" />
    </div>
    <div class="cell small-6">
      Date Prior To Which Fee is Assessed
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="componentData.config.datePriortoWhichFeeIsAssessed" />
    </div>
    <div class="cell small-6">
      Well Transfer Amount
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="componentData.config.wellTransferAmount" />
    </div>
    <div class="cell small-6">
      Well Transfer Sale Date
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="componentData.config.wellTransferSaleDate" />
    </div>
    <div class="cell small-6">
      New Ops on Existing API Permit Type
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="componentData.config.newOpsPermitType" />
    </div>
    <div class="cell small-12 margin-top margin-bottom">
      Context Locations for <u>Bond Data</u>:
    </div>
    <div class="cell small-6">
      Cash in Lieu Amount
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="componentData.config.BNDcashInLieuAmount" />
    </div>
    <div class="cell small-6">
      One-Time Fee Amount
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="componentData.config.BNDoneTimeFeeAmount" />
    </div>
    <div class="cell small-6">
      Surety Type Location
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="componentData.config.suretyTypeField" />
    </div>
  </div>
}
@if (!componentData.config.usePermitFees) {
  <div class="grid-x">
    <div class="cell small-12">
      - OR -
    </div>
    <div class="cell small-12">
      <label for="txtPmt">
        Use Context Location for Amount:
      </label>
      <input id="txtPmt" type="text" [(ngModel)]="componentData.config.amountDue" placeholder="$.data.amountDue.value" [disabled]="componentData.config.usePermitFees"/>
    </div>
    <div class="cell small-12">
      <label for="txtDescription">
        Description to use for Amount Due:
      </label>
      <input id="txtDescription" type="text" [(ngModel)]="componentData.config.amountDescription" placeholder="Required Finanacial Assurance" [disabled]="componentData.config.usePermitFees" />
    </div>
  </div>
}
<div class="grid-x">
  <div class="cell small-12">
    Select Section & Page of Payment Response to direct to upon successful ACH / Credit Card Payment:
  </div>
  <div class="cell small-12">
    <label for="section">
      Section:
      <select name="section" id="section" [(ngModel)]="componentData.config.responseSection" (ngModelChange)="sectionChanged()">
        @for (section of selectedState.sections; track section; let s = $index) {
          <option
            [selected]="s === componentData.config.responseSection"
            [ngValue]="s">
            {{getSectionName(section, s)}}
          </option>
        }
      </select>
    </label>
    <label for="page">
      Page:
      <select name="page" id="page" [(ngModel)]="componentData.config.responsePage">
        @for (page of getPagesForSection(); track page; let p = $index) {
          <option
            [selected]="p === componentData.config.responsePage"
            [ngValue]="p">
            {{getPageTitle(page, p)}}
          </option>
        }
      </select>
    </label>
  </div>
</div>
<div class="grid-x">
  <div class="cell small-12">
    <label for="txtType">
      Context Location for Payment Type
    </label>
    <input id="txtType" type="text" [(ngModel)]="componentData.config.paymentType" />
  </div>
  <div class="cell small-12">
    <label for="txtAppNumber">
      Context Location for Application Number
    </label>
    <input id="txtAppNumber" type="text" [(ngModel)]="componentData.config.applicationNumber" />
  </div>
</div>
